// membership/get-customer-details
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const ReviewList = () => {
  
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const [ searchQuery,setSearchQuery] = useState('');
  const history = useHistory();
  const [packageList, setPackageList] = useState([]);
  const [reply, setReply] = useState('');
  const [popup, setPopup] = useState(false);
  const [currentId, setCurrentId] = useState(null);


  useEffect(() => {
    fetchbookinghistory();
}, [currentPage]);

 // If modal is closed, reset the reply and id
 React.useEffect(() => {
    if (!popup) {
      setReply('');
      setCurrentId(null);
    }
  }, [popup]);

const fetchbookinghistory = async () => {
  const token = localStorage.getItem('token');
//   const userId = localStorage.getItem('userIdd');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/service-review/booking-reviews`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setPackageList(response.data);
      setIsLogin(false);
  } catch (error) {
    setPackageList([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Filter employees before applying pagination
  const filteredUsers = packageList.filter((data) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (data.name && data.name.toLowerCase().includes(searchLower)) ||
      (data.email_id && data.email_id.toLowerCase().includes(searchLower)) ||
      (data.mobile_no && data.mobile_no.toLowerCase().includes(searchLower)) ||
      (data.review_rate && data.review_rate.toString().toLowerCase().includes(searchLower)) ||
      (data.description &&
        data.description.toLowerCase().includes(searchLower)) ||
      (data.shop_reply &&
        data.shop_reply.toLowerCase().includes(searchLower)) 
    );
  });
  
  // Apply pagination to the filtered list
  const paginatedFilteredPackages = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };

  const editReply = (data) => {
    setReply(data.shop_reply || ''); // Load existing reply or empty if none
    setCurrentId(data.id); // Store the current ID for the PUT request
    setPopup(true);
  };

  const updateReply = async () => {
    try {
      setIsLogin(true);
      const tokens = localStorage.getItem('token');
      const response = await axios.put(
        `${var_api}/api/service-review/admin-put/${currentId}`,
        { shop_reply: reply },
        {
          headers: {
            Authorization: `${tokens}`, // Include your token in the headers
          },
        }
      );
  
      if (response.status === 200) {
        setIsLogin(false);
        setPopup(false); // Close the modal after success
        fetchbookinghistory(); // Optionally refresh data or update the UI
      }
    } catch (error) {
      setIsLogin(false); // Ensure you're resetting the login state
      console.error('Error updating reply:', error);
  
      // Log the error response to inspect the issue
      if (error.response) {
        console.error('Response error:', error.response);
        alert(`Error: ${error.response.data.message || 'Failed to update reply'}`);
      } else {
        alert('An unexpected error occurred.');
      }
    }
  };
  
  
  
    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       REVIEW LIST
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none",padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                <div className="row align-items-center" style={{ margin: "0", padding: "0" }}>
                    <div className="col-12 d-flex justify-content-end align-items-center" style={{ marginBottom: "5px" }}>
                        <Form.Control type="text" placeholder="Search..." className="form-control" onChange={handleSearchInput} style={{ maxWidth: "300px" }}/>
                    </div>
                </div>
                
                <Table className="table align-middle table-nowrap mb-0">
                <thead>
          <tr>
            <th>S.no</th>
            <th>Name</th>
            <th>Email ID</th>
            <th>Mobile No.</th>
            <th>Rating </th>
            <th>Description</th>
            <th>Shop Reply</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedFilteredPackages.length > 0 ? (
            paginatedFilteredPackages.map((data, index) => (
              <tr key={data.id}>
                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td>{ data.name ? data.name : '-' }</td>
                <td>{ data.email_id ? data.email_id : '-' }</td>
                <td>{ data.mobile_no ? data.mobile_no : '-' }</td>
                <td>{ data.review_rate ? data.review_rate : '-' }</td>
                <td>{ data.description ? data.description : '-' }</td>
                <td>{ data.shop_reply ? data.shop_reply : '-' }</td>
                <td>
        {data.shop_reply === '' ? (
          <Button
            variant="success"
            style={{ borderRadius: '30px' }}
            onClick={() => editReply(data)}
          >
            Reply
          </Button>
        ) : (
          <Button
            variant="outline-primary"
            style={{ borderRadius: '30px' }}
            onClick={() => editReply(data)}
          >
            Update Reply
          </Button>
        )}
      </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
          </Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredUsers.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
            <Modal show={popup} onHide={() => setPopup(false)} centered size="sm">
  <Modal.Header closeButton>
    <Modal.Title>Give Reply</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3" controlId="description">
        <Form.Label>Reply</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter your reply"
          value={reply}
          onChange={(e) => setReply(e.target.value)}
        />
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
  <Button 
      variant={reply ? "outline-primary" : "dark"} 
      onClick={updateReply}
    >
      {reply ? "Update" : "Submit"} {/* Toggle text based on currentId */}
    </Button>
  </Modal.Footer>
</Modal>

        </div>
        </>
    )
}

export default ReviewList;